<template>
    <div>
        <div class="arrow-up"></div> 
        <v-card class="content">           
            <v-card-text>
                <div class="server-connection">
                    <div class="client">
                        <v-icon x-large>{{clientIcon}}</v-icon>
                        <span class="ip" v-text="$store.state.connectionInfo.client_ip"></span>
                    </div>
                    <div class="connection">
                        <template v-if="$store.getters.connectionStatusObj.connectionStatus">
                            <div class="line"></div>
                            <span class="status good">connected</span>
                        </template>
                        <template v-if="!$store.getters.connectionStatusObj.connectionStatus">
                            <div class="error-x"><v-icon large>mdi-close-network</v-icon></div>
                            <span class="status bad">disconnected</span>
                        </template>
                    </div>
                    <div class="server">
                        <v-icon x-large>mdi-server</v-icon>
                        <span class="ip" v-text="$store.state.connectionInfo.server_ip"></span>
                    </div>
                </div>

                <v-divider class="mt-3 mb-3"></v-divider>

                <div class="connection-details">
                    <div class="connection-item" :class="{bad: !$store.getters.connectionStatusObj.webSocketConnected}">
                        <v-icon class="icon">{{$store.getters.connectionStatusObj.webSocketConnected ? 'mdi-signal' : 'mdi-close-circle'}}</v-icon>
                        <span class="label">Web-Socket</span>
                        <span class="timestamp" v-text="$store.getters.connectionStatusObj.webSocketConnectedTS"></span>
                    </div>
                    <div class="connection-item" :class="{bad: !$store.getters.connectionStatusObj.webAppConnected}">
                        <v-icon class="icon">{{$store.getters.connectionStatusObj.webAppConnected ? 'mdi-signal' : 'mdi-close-circle'}}</v-icon>
                        <span class="label">Web-Server</span>
                        <span class="timestamp" v-text="$store.getters.connectionStatusObj.webAppConnectedTS"></span>
                    </div>
                    <!-- <div class="connection-item" :class="{bad: !$store.getters.connectionStatusObj.telsaServerConnected}">
                        <v-icon class="icon">{{$store.getters.connectionStatusObj.telsaServerConnected ? 'mdi-signal' : 'mdi-close-circle'}}</v-icon>
                        <span class="label">Telsa-Server</span>
                        <span class="timestamp" v-text="$store.getters.connectionStatusObj.telsaServerConnectedTS"></span>
                    </div> -->
                    <div class="connection-item" :class="{bad: !$store.getters.connectionStatusObj.telsasoftCloudConnected}">
                        <v-icon class="icon">{{$store.getters.connectionStatusObj.telsasoftCloudConnected ? 'mdi-signal' : 'mdi-close-circle'}}</v-icon>
                        <span class="label">Cloud-Server</span>
                        <span class="timestamp" v-text="$store.getters.connectionStatusObj.telsasoftCloudConnectedTS"></span>
                    </div>
                </div>

                <span class="app-version-text" v-text="$store.state.applicationVersion" />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'ConnectionInfo',
    data: () => ({

    }),

    computed: {
        clientIcon: function() {
            let device = this.$store.state.user.client_device;
            if(device.device_type == 'desktop') {
                if(device.os_name.toLowerCase() == 'mac') {
                    //return 'mdi-desktop-mac';    
                    return 'mdi-monitor';
                }
                else {
                    return 'mdi-monitor';
                }   
            }
            else if(device.device_type == 'tablet') {
                if(device.os_name.toLowerCase() == 'android') {
                    return 'mdi-tablet-android';
                }
                else if(device.os_name.toLowerCase() == 'ios') {
                    return 'mdi-tablet-ipad';
                }
                else {
                    return 'mdi-tablet';
                }
            }
            else if(device.device_type == 'smartphone') {
                if(device.os_name.toLowerCase() == 'android') {
                    return 'mdi-cellphone-android';
                }
                else if(device.os_name.toLowerCase() == 'ios') {
                    return 'mdi-cellphone-iphone';
                }
                else {
                    return 'mdi-cellphone';
                }
            }
            return 'mdi-monitor';
        },

    },

    methods: {


    },

    mounted() {
    }


    };
</script>

<style scoped>

    .content {
        width: 350px;
    }

    .arrow-up {
        width: 0; 
        height: 0; 
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: relative;
        left: calc(50% - (10px / 2));
        top: 0px;
        border-bottom: 10px solid #424242;
        z-index: 10;
    }

    .server-connection {
        display: block;
    }

    .server-connection .client {
        display: inline-block;
        text-align: center;
        width: 95px;
    }

    .server-connection .connection {
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        text-align: center;
        vertical-align: top;
        margin-top: 23px;
    }

    .server-connection .connection .line {
        height: 2px;
        width: 100px;
        background-color: #4CAF50;
        animation:blinkingText 1s step-start infinite;
    }
    @keyframes blinkingText{
        0%{}
        50%{background-color: #ffffff;}
    }

    .server-connection .connection .error-x {
        margin-top: -18px;
    }
    .server-connection .connection .error-x i {
        color: #FF5252;
        animation:blinkingIcon 1s step-start infinite;
    }
    @keyframes blinkingIcon{
        0%{}
        50%{color: #ffffff;}
    }

    .server-connection .connection .status {
        text-transform: uppercase;
        font-size: 10pt;
        display: block;

    }
    .server-connection .connection .status.good {
        color: #4CAF50;
    }
    .server-connection .connection .status.bad {
        color: #FF5252;
    }

    .server-connection .server {
        display: inline-block;
        text-align: center;
        width: 95px;
    }

    .server-connection .ip {
        display: block;
        font-size: 9pt;
    }


    .connection-details {
        display: block;
        text-align: center;
    }

    .connection-details .connection-item {
        display: block;
        text-transform: uppercase;
        color: #4CAF50;
        margin-left: 20px;
        margin-bottom: 3px;
    }
    .connection-details .connection-item.bad {
        color: #FF5252;
    }

    .connection-details .connection-item .icon {
        display: inline-block;
        width: 30px;
        float: left;
        color: #4CAF50;
    }
    .connection-details .connection-item.bad .icon {
        color: #FF5252;
    }

    .connection-details .connection-item .label {
        text-transform: uppercase;
        vertical-align: bottom;
        display: inline-block;
        width: 120px;
        vertical-align: sub;
    }

    .connection-details .connection-item .timestamp {
        display: inline-block;
        width: 120px;
        vertical-align: sub;
    }

    @media(max-width: 600px) {
        .arrow-up {
            left: calc(50% + 20px);
        }

        .server-connection .client {
            width: calc(((100% - 100px) / 2) - 15px);
        }
        .server-connection .connection .line {
            width: 100px;
        }
        .server-connection .server {
            width: calc(((100% - 100px) / 2) - 15px);
        }

        .server-connection {
            font-size: 6px;
        }
        .server-connection .connection .status {
            font-size: 10pt;
        }
        .server-connection .ip {
            font-size: 10px;
        }

        .connection-details .connection-item .label {
            width: 100px;
        }
        .connection-details .connection-item .timestamp {
            width: 100px;
        }
        .connection-details .connection-item {
            margin-left: 5px;
        }
        .connection-details .connection-item .label {
            font-size: 10pt;
        }
    }

    .app-version-text {
        display: block;
        position: absolute;
        bottom: 0px;
        right: 10px;
        font-weight: bold;
        font-size: 13px;
    }
    
</style>
